import React from 'react'
import AboutHero from './AboutHero'
import AboutUs from './AboutUs'
import MissionVision from './MissionVision'
import OurStory from './OurStory'

const About = () => {
  return (
    <>
        <AboutHero/>
        <AboutUs/>
        <MissionVision/>
        <OurStory/>
    </>
  )
}

export default About